module.exports = __webpack_public_path__ + "static/img/22a.846805d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22a.jpg
// module id = yjTU
// module chunks = 0